// app/javascript/controllers/contact_picker_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["list", "search"]

    connect() {
        this.rows = Array.from(this.listTarget.querySelectorAll(".contact-row"))
    }

    selectAll(e) {
        e.preventDefault()
        this.listTarget.querySelectorAll("input[type='checkbox']").forEach(cb => cb.checked = true)
    }

    clearAll(e) {
        e.preventDefault()
        this.listTarget.querySelectorAll("input[type='checkbox']").forEach(cb => cb.checked = false)
    }

    close(e) {
        e?.preventDefault()
        this.element.closest("turbo-frame")?.remove()
    }

    filter() {
        const q = (this.searchTarget.value || "").toLowerCase()
        this.rows.forEach(row => {
            const text = row.innerText.toLowerCase()
            row.style.display = text.includes(q) ? "" : "none"
        })
    }

    // Wire up input -> filter
    searchTargetConnected(el) {
        el.addEventListener("input", () => this.filter())
    }
}